export default "__VITE_ASSET__e0L0JPMr__ 778w";